import React, { PropsWithChildren } from 'react';
import s from './Sidebar.module.scss';
import { Link } from 'react-router-dom';
import { ROUTES } from 'configs/routeConstants';
import T from '@data/text/header.json';
import { getIsLoggedIn } from 'store/auth/auth-selectors';
import { useSelector } from 'react-redux';
import { useHotkeys } from 'hooks/useHotkeys';
import { useClickOutside } from 'hooks/useClickOutside';
import LogoutButton from '../buttons/logoutButton/LogoutButton';
import AccountButton from '../buttons/accountButton/AccountButton';
import useMetrics from '@hooks/useMetrics';
import { METRIC_EVENTS, METRIC_EVENTS_TRIGGERS } from '@configs/metrics/events';
import { isMentalHealthEnabled } from '@configs/features';
// import telegramIcon from '@assets/svg/icon-telegram.svg';
// import vkIcon from '@assets/svg/icon-vk.svg';
// import dzenIcon from '@assets/svg/icon-dzen.svg';
interface SidebarProps {
  /** открыто / закрыто */
  isOpen: boolean;
  /** вызвать, чтобы закрыть (ESC / клик-по-фону / кнопка-крестик) */
  onClose: () => void;
  /** ‘left’ | ‘right’; по умолчанию – left */
  side?: 'left' | 'right';
  /** скрыть кноп­ку «крестик» */
  hideCloseButton?: boolean;
  /** заголовок */
  title?: string;
}

const Sidebar: React.FC<PropsWithChildren<SidebarProps>> = ({
  isOpen,
  onClose,
  title = T.sidebar.title,
  side = 'left',
  hideCloseButton,
}) => {
  const isLoggedIn = useSelector(getIsLoggedIn);

  const { trackEvent } = useMetrics();

  useHotkeys([['esc', onClose]]);
  const ref = useClickOutside(() => isOpen && onClose());

  const handleMainPageClick = () => {
    trackEvent(METRIC_EVENTS.main_page, METRIC_EVENTS_TRIGGERS.sidebar);
    onClose();
  };
  const handleChapterChoose = () => {
    trackEvent(METRIC_EVENTS.my_health_chapter_choose, METRIC_EVENTS_TRIGGERS.sidebar, {
      chapter_name: METRIC_EVENTS_TRIGGERS.myHealth,
    });
    onClose();
  };
  const handleContactsClick = () => {
    trackEvent(METRIC_EVENTS.contacts_page, METRIC_EVENTS_TRIGGERS.sidebar);
    onClose();
  };
  const handleQaBlockClick = () => {
    trackEvent(METRIC_EVENTS.qa_block, METRIC_EVENTS_TRIGGERS.sidebar);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className={s.backdrop}>
      <div className={s.overlay} />

      {/* сама панель */}
      <aside ref={ref} className={s.panel} data-side={side}>
        <nav className={s.sidebarNav}>
          <div className={s.sidebarHeader}>
            <h5 className={s.sidebarTitle}>{title}</h5>
            {!hideCloseButton && (
              <button
                className={s.closeBtn}
                onClick={onClose}
                aria-label={T.sidebar.closeAriaLabel}
              >
                ✕
              </button>
            )}
          </div>
          <Link to={ROUTES.root} onClick={handleMainPageClick} className={s.sidebarLink}>
            {T.sidebar.home}
          </Link>
          <Link to={ROUTES.myHealth.root} onClick={handleChapterChoose} className={s.sidebarLink}>
            {T.sidebar.myHealth}
          </Link>
          {isMentalHealthEnabled && (
            <Link
              to={ROUTES.myHealth.mentalHealth}
              onClick={handleChapterChoose}
              className={s.sidebarLink}
            >
              {T.sidebar.mentalHealth}
            </Link>
          )}
          <Link to={ROUTES.contacts} onClick={handleContactsClick} className={s.sidebarLink}>
            {T.sidebar.contacts}
          </Link>
          <Link to={ROUTES.faq} onClick={handleQaBlockClick} className={s.sidebarLink}>
            {T.sidebar.faq}
          </Link>
        </nav>

        {/*<div className={s.social}>*/}
        {/*  <a href={ROUTES.external.telegram} target="_blank" rel="noreferrer">*/}
        {/*    <button className={s.socialLink}>*/}
        {/*      <img src={telegramIcon} alt="telegram" />*/}
        {/*    </button>*/}
        {/*  </a>*/}
        {/*  <a href={ROUTES.external.vk} target="_blank" rel="noreferrer">*/}
        {/*    <button className={s.socialLink}>*/}
        {/*      <img src={vkIcon} alt="vk" />*/}
        {/*    </button>*/}
        {/*  </a>*/}
        {/*  <a href={ROUTES.external.dzen} target="_blank" rel="noreferrer">*/}
        {/*    <button className={s.socialLink}>*/}
        {/*      <img src={dzenIcon} alt="dzen" />*/}
        {/*    </button>*/}
        {/*  </a>*/}
        {/*</div>*/}
        {isLoggedIn ? (
          <LogoutButton onClick={onClose} style={{ maxWidth: '120px' }}>
            {T.sidebar.logout}
          </LogoutButton>
        ) : (
          <AccountButton labelSigned={T.account.link} labelUnsigned={T.account.signIn} />
        )}

        {/* <div className={s.telegramBlock}>
          <span className={s.telegramBlockTitle}>Скачайте BionMax на смартфон</span>
          <button className={s.telegramBtn}>
            Открыть в Телеграмм&nbsp;
            <img src={telegramIcon} alt="telegram" />
          </button>
        </div> */}
      </aside>
    </div>
  );
};

export default Sidebar;
